/**
 * JAKI MODEL WDROŻENIA POKAZAĆ PRZY KODZIE REJESTRACYJNYM — funkcja CZYSTA.
 *
 * ══════════════════════════════════════════════════════════════════════════════════════════════
 *  ⚠️ POWSTAŁO NA ZGŁOSZENIE (31.08.2026): „Rodzaj wdrożenia wyspy powinien się wyświetlać
 *  w zakładce wydane kody — w tej chwili nie wiadomo, czy ktoś założył jako zwykły czy smart sync".
 *
 *  ⚠️⚠️ DWA POLA O TEJ SAMEJ NAZWIE ZNACZĄ CO INNEGO i to jest cały powód, dla którego ta reguła
 *  jest funkcją, a nie wyrażeniem w JSX:
 *    • `AgentEnrollment.tryb` — w jakim trybie ten kod ZAŁOŻY wyspę. Przy kodzie DOŁĄCZAJĄCYM jest
 *      bez znaczenia: dołączenie trybu nie dotyka, więc w wierszu zostaje domyślne `ZWYKLY`.
 *    • `SyncGroup.tryb` — jak wyspa jest wdrożona TERAZ. To jest odpowiedź na pytanie ze zgłoszenia.
 *
 *  Pokazanie pola z kodu przy kodzie dołączającym kłamałoby przy KAŻDEJ wyspie Smart Sync —
 *  a kłamałoby wiarygodnie, bo „zwykły" jest odpowiedzią prawdziwą u większości klientów.
 *
 *  ⚠️ TRYB WYSPY JEST TEŻ ODPOWIEDZIĄ AKTUALNĄ. Wyspę wolno przełączyć po założeniu, więc tryb
 *  zapisany na kodzie wydanym w lipcu opisuje przeszłość, a nie stan.
 * ══════════════════════════════════════════════════════════════════════════════════════════════
 */

export type TrybWyspy = 'ZWYKLY' | 'SMART_SYNC';

export type KodDoTrybu = {
  founding: boolean;
  /** `null` = kod założycielski, którym jeszcze nikt nie założył wyspy. */
  groupId: string | null;
  /** Tryb zapisany NA KODZIE — patrz ostrzeżenie wyżej. */
  tryb: TrybWyspy;
  /** Tryb WYSPY, do której kod należy; `null`, gdy wyspy jeszcze nie ma. */
  group: { tryb: TrybWyspy } | null;
};

export type TrybNaLiscie = {
  tryb: TrybWyspy;
  /**
   * `true` = to jeszcze ZAMIAR, nie stan: kod założycielski, którym nikt nie zarejestrował maszyny.
   * Ekran musi to podpisać, bo „Smart Sync" przy kodzie nieużytym znaczy „taka wyspa powstanie",
   * a nie „taka wyspa jest".
   */
  zZalozenia: boolean;
};

export function trybNaLiscieKodow(k: KodDoTrybu): TrybNaLiscie {
  /**
   * ⚠️ WYSPA WYGRYWA ZAWSZE, GDY ISTNIEJE — także przy kodzie założycielskim, którym ją założono.
   * Gdyby wygrywał kod, wyspa przełączona po wdrożeniu pokazywałaby na tej liście stary tryb,
   * czyli dokładnie tę nieprawdę, którą to zgłoszenie miało usunąć.
   */
  if (k.group !== null) return { tryb: k.group.tryb, zZalozenia: false };
  return { tryb: k.tryb, zZalozenia: k.founding };
}
